import { PlayResponse } from '../../types';

export const localBonusBallSpinData: PlayResponse = {
    round: 'uid',
    step: 'uid',
    balance: 1462884222196,
    resp: {
        game_type: 'CRAZY_CRAZY_CLAW',
        win: true,
        win_amount: 1100000000,
        multiplier: '11',
        win_type: 'BIG',
        ball_spin_result: {
            multiplier_left: '3',
            multiplier_right: '10',
            side: 'RIGHT'
        },
        final_result: true
    },
    final: true
};
